<template>
  <div>
    <el-card shadow="always" style="box-shadow:none">
      <EditForm
        ref="editForm"
        :disabled="disabled"
        :opt-type="pageType"
        :disabledPrint="disabledPrint"
        :amzFtyNoticeInCode="amzFtyNoticeInCode"
      />
      <div class="d-flex justify-content-end mt-2" v-if="!disabled">
        <el-button type="primary" size="small" @click="$refs.editForm.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-awsBiz-ftyInvInNotice-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return (
        this.pageType === 'detail' ||
        this.pageType === 'send' ||
        this.pageType === 'confirm'
      )
    },
    amzFtyNoticeInCode() {
      return this.params.amzFtyNoticeInCode
    },
    disabledPrint() {
      const amzFtyNoticeInStatus = this.params.amzFtyNoticeInStatus
      return (
        amzFtyNoticeInStatus !== 'S' &&
        amzFtyNoticeInStatus !== 'F' &&
        amzFtyNoticeInStatus !== 'Y'
      )
    },
  },
}
</script>
